import React from "react";
import { Input } from "../../../common/u1/Input";
import { SelectField } from "../../../common/u1/SelectField";
import { FieldLabel } from "../../../common/u1/FieldLabel";
import { codeToFlagEmoji } from "../../../common/u1/countryFlag";
import { ShieldIcon } from "../../../../assets/ui/icons";

/* Step 5 — the public contact details. */
export const ContactStep = ({
  email = "",
  onEmailChange = () => {},
  dialCountry = "AE",
  onDialCountryChange = () => {},
  dialCodeOptions = [],
  phone = "",
  onPhoneChange = () => {},
  errors = {},
}) => (
  <div className="grid gap-3.5">
    <Input
      id="claim-contact-email"
      label="Email Address"
      labelVariant="caption"
      required
      type="email"
      value={email}
      onChange={(e) => onEmailChange(e.target.value)}
      placeholder="info@company.ae"
      hint="A general inbox shown publicly on your TREVEX profile."
      error={errors.email}
    />

    <div>
      {/* A span, not a label: the row below is two controls, and a label can
          only point at one of them. Each carries its own accessible name. */}
      <FieldLabel as="span" required>
        Contact No.
      </FieldLabel>
      <div className="mt-1.5 grid gap-2.5 sm:grid-cols-[170px_1fr]">
        <SelectField
          id="claim-dial-code"
          aria-label="Country dial code"
          value={dialCountry}
          onChange={(e) => onDialCountryChange(e.target.value)}
          options={dialCodeOptions}
          prefix={codeToFlagEmoji(dialCountry)}
        />
        <Input
          id="claim-contact-phone"
          aria-label="Contact number"
          inputMode="tel"
          value={phone}
          onChange={(e) => onPhoneChange(e.target.value)}
          placeholder="4 212 3456"
          error={errors.phone}
        />
      </div>
    </div>

    <div className="mt-1 flex items-start gap-2.5 rounded-[10px] border border-[var(--orange-border)] bg-[var(--orange-soft)] px-3.5 py-3 text-[13px] leading-[1.5] text-[var(--ink)] font-sans">
      <ShieldIcon className="mt-0.5 shrink-0 text-[var(--orange)]" />
      <span>
        <b>Almost done.</b> After you submit, our team will verify your
        authorized representative status using the license and ID details
        you&apos;ve provided.
      </span>
    </div>
  </div>
);

export default ContactStep;
